import { render } from "./AppPopUp.vue?vue&type=template&id=9f805aaa&scoped=true"
import script from "./AppPopUp.vue?vue&type=script&lang=js"
export * from "./AppPopUp.vue?vue&type=script&lang=js"

import "./AppPopUp.vue?vue&type=style&index=0&id=9f805aaa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9f805aaa"

export default script